<template>
  <div id="choose-payment-type-container">
    <h5 id="payment-type-title">{{ labels.payment.paymentType[language] }}</h5>
    <div
      v-if="(isPda || (!isPda && !servicesWithStrictCardPayment.includes(serviceId))) && (tableType=='TABLE_AT_HOTEL' || tableType=='UMBRELLA_AT_HOTEL' || tableType=='HOTEL_ROOM')"
      class="payment-option align-center mb-7"
    >
      <input
        class="close-table-payment-type-input"
        type="radio"
        value="ROOM_CHARGE"
        @change="onChangePaymentType"
        v-model="paymentType"
      />
      <h6
        style="cursor:pointer; margin-bottom:0px"
        :class="{'on-credit-selected-payment' : paymentType=='ROOM_CHARGE'}"
        @click="selectPaymentType('ROOM_CHARGE')"
      >{{tableType=='HOTEL_ROOM' ? labels.payment.chargeToRoom[language]: labels.payment.chargeAtRoom[language]}}</h6>
      <font-awesome-icon
        class="payment-type-icon"
        :class="{ onCreditColor: paymentType == 'ROOM_CHARGE' }"
        icon="bed"
        @click="selectPaymentType('ROOM_CHARGE')"
      />
    </div>
    <!-- <div v-if="(tableType=='TABLE_AT_HOTEL' || tableType=='UMBRELLA_AT_HOTEL') && tableOpeningsEnabled">
      <div class="payment-option" style="margin-right: 16px;">
        <input
          class="close-table-payment-type-input"
          type="radio"
          value="CASH"
          @change="onChangePaymentType"
          v-model="paymentType"
        />
        <h6 @click="selectPaymentType('CASH')">{{ labels.payment.cashOrCard[language] }}</h6>
      </div>
    </div>-->
    <div>
      <div
        v-if="paymentTypes.includes('CASH') && !tableIdsToHideCashPayment.includes(routeTableId) && (isPda || (!isPda && !servicesWithStrictCardPayment.includes(serviceId)))"
        class="payment-option align-center mb-7"
        style="margin-right: 16px;"
      >
        <input
          class="close-table-payment-type-input"
          type="radio"
          value="CASH"
          @change="onChangePaymentType"
          v-model="paymentType"
        />
        <h6
          style="cursor: pointer; margin-bottom:0px"
          :class="{'cash-selected-payment' : paymentType=='CASH'}"
          @click="selectPaymentType('CASH')"
        >{{ labels.payment.cash[language] }}</h6>
        <font-awesome-icon
          class="payment-type-icon"
          :class="{ greenColor: paymentType == 'CASH' }"
          icon="money-bill"
          @click="selectPaymentType('CASH')"
        />
      </div>
      <div
        class="payment-option align-center mb-7"
        :class="{ 'separate-line': (supportsBankAccountPayment || supportsOnCreditPayment) && isPda}"
        v-if="paymentTypes.includes('CARD_TERMINAL') && !tableIdsToHideCardPayment.includes(routeTableId) && (isPda || (!isPda && !servicesWithStrictCardPayment.includes(serviceId)))"
      >
        <input
          class="close-table-payment-type-input"
          type="radio"
          value="CARD_TERMINAL"
          @change="onChangePaymentType"
          v-model="paymentType"
        />
        <h6
          style="cursor: pointer; margin-bottom:0px"
          :class="{'card-selected-payment' : paymentType=='CARD_TERMINAL'}"
          @click="selectPaymentType('CARD_TERMINAL')"
        >{{ tableType=='DELIVERY' || tableType=='DELIVERY_TABLE' ? labels.payment.cardOnDelivery[language] : labels.payment.cardAtTheStore[language] }}</h6>
        <font-awesome-icon
          class="payment-type-icon"
          :class="{ cardTerminalColor: paymentType == 'CARD_TERMINAL' }"
          icon="credit-card"
          @click="selectPaymentType('CARD_TERMINAL')"
        />
      </div>
      <div class="payment-option align-center mb-7" v-if="supportsBankAccountPayment && isPda">
        <input
          class="close-table-payment-type-input"
          type="radio"
          value="BANK_ACCOUNT"
          @change="onChangePaymentType"
          v-model="paymentType"
        />
        <h6
          style="cursor: pointer; margin-bottom:0px"
          :class="{'bank-account-selected-payment' : paymentType=='BANK_ACCOUNT'}"
          @click="selectPaymentType('BANK_ACCOUNT')"
        >{{ labels.payment.bankAccount[language] }}</h6>
        <font-awesome-icon
          class="payment-type-icon"
          :class="{ bankAccountColor: paymentType == 'BANK_ACCOUNT' }"
          icon="hotel"
          @click="selectPaymentType('BANK_ACCOUNT')"
        />
      </div>
      <div class="payment-option align-center mb-7" v-if="supportsOnCreditPayment && isPda">
        <input
          class="close-table-payment-type-input"
          type="radio"
          value="ON_CREDIT"
          @change="onChangePaymentType"
          v-model="paymentType"
        />
        <h6
          style="cursor: pointer; margin-bottom:0px"
          :class="{'on-credit-selected-payment' : paymentType=='ON_CREDIT'}"
          @click="selectPaymentType('ON_CREDIT')"
        >{{ labels.payment.onCredit[language] }}</h6>
        <font-awesome-icon
          class="payment-type-icon"
          :class="{ onCreditColor: paymentType == 'ON_CREDIT' }"
          icon="history"
          @click="selectPaymentType('ON_CREDIT')"
        />
      </div>
    </div>

    <div v-if="hasOnlinePaymentsByCard && !isPda" class="payment-option align-center mb-7">
      <input
        class="close-table-payment-type-input"
        type="radio"
        value="CARD"
        @change="onChangePaymentType"
        v-model="paymentType"
      />
      <h6
        style="cursor: pointer; margin-bottom:0px"
        :class="{'card-selected-payment' : paymentType=='CARD'}"
        @click="selectPaymentType('CARD')"
      >{{ labels.payment.cardOnline[language] }}</h6>
      <font-awesome-icon
        class="payment-type-icon"
        :class="{ cardTerminalColor: paymentType == 'CARD' }"
        icon="credit-card"
        @click="selectPaymentType('CARD')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ChoosePayment",
  props: ["hasOnlinePaymentsByCard", "tableType", "tableOpeningsEnabled", "tableShowsPaymentsOptionNoMatterWhat", "paymentTypes", "supportsBankAccountPayment", "isPda", "supportsOnCreditPayment"],
  components: {
  },
  data() {
    return {
      paymentType: 'CASH',
      tableIdsToHideCashPayment: ['12534', 12534, '12351', 12351, '13502', 13502, '13504', 13504, '13507', 13507, '13594', 13594], //TODO fix this properly from server and consume the selected table not the route table
      tableIdsToHideCardPayment: ['12534', 12534, '12351', 12351, '13502', 13502, '13504', 13504, '13507', 13507, '13594', 13594, '13817', 13817], //TODO fix this properly from server and consume the selected table not the route table
      routeTableId: null,
      servicesWithStrictCardPayment: [989, 994, 1285, 1419]
    }
  },
  watch: {

  },
  computed: {
    language() {
      return this.$store.getters.getLanguage;
    },

    serviceId() {
      return this.$store.getters.getServiceId;
    },

  },
  methods: {
    selectPaymentType(paymentType) {
      this.paymentType = paymentType;
      this.$emit("payment-type-select", this.paymentType)
    },
    onChangePaymentType() {
      this.$emit("payment-type-select", this.paymentType)
    }
  },
  mounted() {
    this.routeTableId = this.$router.currentRoute.params.tableId;

    if (((this.tableType == 'TABLE_AT_HOTEL' || this.tableType == 'UMBRELLA_AT_HOTEL') && (!this.tableOpeningsEnabled || this.tableShowsPaymentsOptionNoMatterWhat)) || this.tableType == 'HOTEL_ROOM') {
      this.paymentType = 'ROOM_CHARGE';
      this.$emit("payment-type-select", 'ROOM_CHARGE')
    } else if (!this.paymentTypes.includes('CASH') && this.paymentTypes.includes('CARD_TERMINAL')) {
      this.paymentType = 'CARD_TERMINAL';
      this.$emit("payment-type-select", 'CARD_TERMINAL')
    } else if (!this.paymentTypes.includes('CASH') && !this.paymentTypes.includes('CARD_TERMINAL')) {
      this.paymentType = 'ON_CREDIT';
      this.$emit("payment-type-select", 'ON_CREDIT')
    }

    if (this.tableIdsToHideCashPayment.includes(this.routeTableId) && this.tableIdsToHideCardPayment.includes(this.routeTableId)) {
      this.paymentType = 'ON_CREDIT';
      this.$emit("payment-type-select", 'ON_CREDIT')
    } else if (this.tableIdsToHideCashPayment.includes(this.routeTableId) && !this.tableIdsToHideCardPayment.includes(this.routeTableId)) {
      this.paymentType = 'CARD_TERMINAL';
      this.$emit("payment-type-select", 'CARD_TERMINAL')
    }

    if (this.routeTableId == 17153 || this.routeTableId == '17153') {
      this.servicesWithStrictCardPayment = [];
    }

    if (!this.isPda && this.servicesWithStrictCardPayment.includes(this.serviceId)) {
      this.paymentType = 'CARD';
      this.$emit("payment-type-select", 'CARD')
    }
  }
};
</script>

<style scoped>
#choose-payment-type-container {
  width: 90%;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-bottom: 1vh;
  border-bottom: 1px solid rgba(116, 135, 150, 0.2);
  padding: 2px 0 2px 0;
  color: black;
}

#payment-type-title {
  font-weight: 600;
  font-size: 15px;
}

.payment-option {
  display: flex;
  flex-direction: row;
}

.payment-type-icon {
  margin-left: 6px;
  color: rgb(95, 95, 95);
  cursor: pointer;
}

.greenColor {
  color: #198b4a !important;
}

.cardTerminalColor {
  color: #17a2b8 !important;
}

.bankAccountColor {
  color: #0275d8 !important;
}

.onCreditColor {
  color: #d8a200 !important;
}

.payment-option > h6 {
  font-size: 14px;
}

.input {
  accent-color: #198b4a;
  margin-bottom: 6px;
  margin-right: 5px;
  cursor: pointer;
}

.close-table-payment-type-input {
  accent-color: #198b4a;
  margin-right: 5px;
}

.align-center {
  align-items: center;
}

.mb-7 {
  margin-bottom: 7px;
}

.separate-line {
  margin-bottom: 11px !important;
  padding-bottom: 11px !important;
  border-bottom: 1px dashed #717171;
}

.cash-selected-payment {
  background-color: #198b4a;
  color: #ffffff;
  border-radius: 4px;
  padding: 2px 5px 2px 5px;
}

.card-selected-payment {
  background-color: #17a2b8;
  color: #ffffff;
  border-radius: 4px;
  padding: 2px 5px 2px 5px;
}

.bank-account-selected-payment {
  background-color: #0275d8;
  color: #ffffff;
  border-radius: 4px;
  padding: 2px 5px 2px 5px;
}

.on-credit-selected-payment {
  background-color: #ffc107;
  border-radius: 4px;
  padding: 2px 5px 2px 5px;
}
</style>